import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { investmentHorizonOption } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'investment-horizon',
    templateUrl: './investment-horizon.component.html',
    styleUrls: ['./investment-horizon.component.scss'],
    standalone: false
})
export class InvestmentHorizonComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = investmentHorizonOption;
  constructor(
    protected formConstructor: PrFormConstructor,

    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this, 'accountInformations');
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
